import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormMode } from '../utils/extensions/constantEx'
import { NurseServiceBookingContextProvider } from '../utils/contexts/nurseServiceBookingFormContext';
import ServiceBookingForm from './serviceBookingForm';

export default function ServiceBookingFormWrapper(props) {

    const { formMode } = props;
    const location = useLocation();

    const [selectedBookingId, setSelectedBookingId] = useState(0);
    const [selectedNurseId, setSelectedNurseId] = useState(0);
    const [selectedNurseName, setSelectedNurseName] = useState('');
    const [formOpenMode, setFormOpenMode] = useState(formMode ?? FormMode.NewMode);


    useEffect(() => {

        if (location && location.state && location.state.selectedId && location.state.selectedId > 0) {
            setFormOpenMode(FormMode.ViewMode);
            setSelectedBookingId(location.state.selectedId);
        } else {
            setFormOpenMode(formMode ?? FormMode.NewMode);
            setSelectedBookingId(0);

            if (location && location.state && location.state.selectedNurseId && location.state.selectedNurseId > 0) {
                setSelectedNurseId(location.state.selectedNurseId);
                setSelectedNurseName(location.state.selectedNurseName ?? '');
            }
        }
    }, [location]);


    return (
        <NurseServiceBookingContextProvider>
            <ServiceBookingForm formMode={formOpenMode} selectedBookingId={selectedBookingId} selectedNurseId={selectedNurseId} selectedNurseName={selectedNurseName} />
        </NurseServiceBookingContextProvider>
    );

}
